module.exports = __webpack_public_path__ + "static/img/header_icon.c482f412.jpg";